import getPaymentResult from './fetch-payment-result.js';
import constants from './../../payment/common/lib/utils/constants.js';
import Cookies from './../../libs/tomcat-cookies.js';
import config from './../../store/index.js';
import { setNavigationCookies, lastProduct } from './../../store/cookies.js';
import { basePathname, push } from './../../store/history.js';
import CountUp from './../../payment/util/count-up.js';
import pixelTracking from './../../pixel-tracking/pixel-tracking.js';
import { fetchJson } from './../../core/ajax-json.js';
import currencyFormatter from './../../libs/currency-formatter.js';
import { getLocale } from './../../libs/locale.js';


let globalNotificationElem;
let paymentResultElem;
let paymentType; // deposit or withdraw

const countUpOptions = {
	useEasing: true,
	useGrouping: false,
	separator: '',
	decimal: '',
	prefix: '',
	suffix: ''
};

function showBalance() {
	const balanceElem = paymentResultElem.getElementsByClassName('js-balance')[0];
	let formattedBalance;
	function setFormattedBalance() {
		balanceElem.innerHTML = formattedBalance;
	}
	fetchJson('/player/balance')
		.then((response) => {
			balanceElem.classList.remove('u-hide');
			const balanceTextElem = paymentResultElem.getElementsByClassName('js-balance-text')[0];
			balanceTextElem.classList.remove('u-hide');
			paymentResultElem.getElementsByClassName('js-progress-bar')[0].classList.add('notify__progress-bar--fill-success');
			const tickerElement = paymentResultElem.getElementsByClassName('js-balance-ticker')[0];
			const uniqueId = ((new Date()).getTime()).toString();
			tickerElement.id = uniqueId;
			const startValue = Cookies.get('lastBalance') || 0;
			const ticker = new CountUp(uniqueId, startValue, response.result.amount, 0, 2, countUpOptions);
			fetchJson('/player/currency')
				.then((response2) => {
					formattedBalance = currencyFormatter.format(response.result.amount, response2.result, getLocale());
					ticker.start(setFormattedBalance);
				});
		});
}

function showSuccessIcon() {
	paymentResultElem.getElementsByClassName('js-icon-success')[0].classList.remove('u-hide');
}

function showSuccess() {
	showSuccessIcon();
	const titleElem = paymentResultElem.getElementsByClassName('js-notify__main-title')[0];
	if (paymentType === 'withdraw') {
		titleElem.innerHTML = titleElem.dataset.withdrawSuccessTitle;
	} else {
		titleElem.innerHTML = titleElem.dataset.depositSuccessTitle;
	}
	const textElem = paymentResultElem.getElementsByClassName('js-notify__main-text')[0];
	if (paymentType === 'withdraw') {
		textElem.innerHTML = textElem.dataset.withdrawSuccessText;
	} else {
		textElem.innerHTML = textElem.dataset.depositSuccessText;

	}
	showBalance();
}

function cleanUp() {
	document.querySelector('.notify--is-open').classList.remove('notify--is-open');
	globalNotificationElem.classList.remove('global-notification--is-open');
}


function setupCloseButtonClickHandler() {
	const closeButtonElem = paymentResultElem.getElementsByClassName('js-close')[0];
	const isLandingPage = config.page && config.page === 'landing';

	closeButtonElem.onclick = () => {
		cleanUp();
		paymentResultElem.remove();
		if (lastProduct() && !isLandingPage) {
			push(basePathname());
		} else if (lastProduct() && isLandingPage) {
			// Weird hack to remove querystring from URL during refresh
			window.history.replaceState({}, 'Payment Result', window.location.pathname.split('?')[0]);
			window.location.pathname = '/global';
		} else {
			fetchJson('/site')
				.then((response) => {
					const defaultPath = response.result.toLowerCase();
					setNavigationCookies(defaultPath);
					window.history.replaceState({}, 'Payment Result', window.location.pathname.split('?')[0]);
					window.location.pathname = '/global';
				});
		}
	};
}

function showFailedButtons() {
	const buttonWrapperElem = paymentResultElem.getElementsByClassName('js-notify__button-wrapper')[0];
	buttonWrapperElem.classList.remove('u-hide');

	const tryAgainButtonElem = buttonWrapperElem.getElementsByClassName('js-try-again-button')[0];
	tryAgainButtonElem.onclick = function tryAgainClickHandler() {
		if (paymentType === 'withdraw') {
			window.location.pathname = '/account/withdraw';
		} else {
			window.location.pathname = `/${paymentType}`;
		}
	};
	const supportButtonElem = buttonWrapperElem.getElementsByClassName('js-support-button')[0];
	supportButtonElem.onclick = function supportClickHandler() {
		const link = supportButtonElem.dataset.link;
		window.open(link);
	};
}

function showFailedProgressBar() {
	paymentResultElem.getElementsByClassName('js-progress-bar')[0].classList.add('notify__progress-bar--fill-fail');
}

function showFailedIcon() {
	paymentResultElem.getElementsByClassName('js-icon-fail')[0].classList.remove('u-hide');
}

function showFailed() {
	showFailedIcon();
	const titleElem = paymentResultElem.getElementsByClassName('js-notify__main-title')[0];
	if (paymentType === 'withdraw') {
		titleElem.innerHTML = titleElem.dataset.withdrawFailTitle;
	} else {
		titleElem.innerHTML = titleElem.dataset.depositFailTitle;
	}
	const textElem = paymentResultElem.getElementsByClassName('js-notify__main-text')[0];
	if (paymentType === 'withdraw') {
		textElem.innerHTML = textElem.dataset.withdrawFailText;
	} else {
		textElem.innerHTML = textElem.dataset.depositFailText;
	}
	showFailedButtons();
	showFailedProgressBar();
}

function showTextArea() {
	paymentResultElem.getElementsByClassName('js-text-wrapper')[0].classList.remove('u-hide');
}

function hideSpinner() {
	paymentResultElem.getElementsByClassName('spinner')[0].classList.add('u-hide');
}

function showDepositPending() {
	paymentResultElem.getElementsByClassName('js-icon-pending-deposit')[0].classList.remove('u-hide');
	const titleElem = paymentResultElem.getElementsByClassName('js-notify__main-title')[0];
	titleElem.innerHTML = titleElem.dataset.depositPendingTitle;
	const textElem = paymentResultElem.getElementsByClassName('js-notify__main-text')[0];
	textElem.innerHTML = textElem.dataset.depositPendingText;
	showBalance();
}

function extractValue(str, searchStr) {
	const startOfSection = str.indexOf(searchStr);
	const startOfValue = str.indexOf('\': \'', startOfSection) + 4;
	const endOffValue = str.indexOf('\'', startOfValue);

	return str.substring(startOfValue, endOffValue);
}

function viewUpdateCallback(data, state) {
	if (data === undefined) {
		return;
	}
	hideSpinner();
	if (paymentType === 'deposit' && state === constants.PENDING) {
		showDepositPending();
	} else if (state === constants.PENDING || state === constants.SUCCESS) {
		showSuccess();
		if (paymentType === 'deposit') {
			const amount = extractValue(data.pixelTrackingData, 'pixel_depositAmount');
			pixelTracking.push('deposit', amount);
		}
	} else {
		showFailed();
	}
	showTextArea();
}

export default {
	init(type, queryParameters) {
		paymentType = type;

		globalNotificationElem = document.getElementsByClassName('js-global-notification')[0];
		const paymentResultElemTemplate = document.getElementsByClassName('js-payment-result-information-message')[0];
		paymentResultElemTemplate.classList.add('u-hide');
		paymentResultElem = paymentResultElemTemplate.cloneNode(true);
		paymentResultElem.classList.remove('u-hide');
		paymentResultElemTemplate.parentNode.insertBefore(paymentResultElem, paymentResultElemTemplate.nextSibling);
		setupCloseButtonClickHandler();

		getPaymentResult.init(queryParameters, viewUpdateCallback, paymentType);
	}
};



// WEBPACK FOOTER //
// ./mobile-core/src/components/payment-result/payment-result-view.js